import React, { useState, useEffect } from "react";
import "./App.css";
import Routing from "./routing/Routing";
import "react-toastify/dist/ReactToastify.css";
import { getUser } from "./store/actions/AuthAction";
import { useDispatch } from "react-redux";
import { ToastContainer} from "react-toastify";

function App() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUser(setLoading));
  }, []);

  return (
    <div>
      <ToastContainer />
      {loading ?<div className="loaderContainer"><div className="loader"/></div>: <Routing />}
    </div>
  );
}

export default App;
